import iconMoneyArrow from './img/icon-money-arrow.svg';
import daiCoinIcon from './img/dai-coin-icon.svg';
import imageInvestments from './img/image-investments.svg';

export const images = {
    money: iconMoneyArrow,
    dai: daiCoinIcon,
    image: imageInvestments,
};